import template from 'lodash/template';
import domify from 'domify';

class Component {
  /**
   * @prop {Number} counter
   */
  counter = -1;

  /**
   * Creates the component object
   */
  constructor() {
    this.template = template(this.view());
  }

  /**
   * Renders the template
   *
   * @param {Object} data - The data to render the template
   * @return {String}
   */
  render(data) {
    this.counter++;

    const template = this.template(this.data(data));

    return domify(template);
  }

  /**
   * Get the template data with its counter
   *
   * @param {Object} data - The template base data
   * @return {Object}
   */
  data(data) {
    return Object.assign({}, data, {counter: this.counter});
  }

  /**
   * Get the template string to be compiled
   *
   * @return {String}
   */
  view() {
    return document.getElementById('etapa-aprovacao')
      .innerHTML
      .replace(/&gt;/g, '>')
      .replace(/&lt;/g, '<');
  }
}

export default Component;
